import { Divider, Flex, Text } from '@/components/ui';

const Copyrights = () => {
  return (
    <Flex
      align="center"
      justify="center"
      className="app-layout__footer__copyrights"
    >
      <Flex width="full" align="center" gap="4">
        <Text size="2xsmall" color="gray">
          © North American Science Associates, LLC 2025
        </Text>
        <Divider orientation="vertical" size="small" />
        <Text size="2xsmall" color="gray">
          <a href="https://namsa.com/terms-of-use/">Terms & Conditions</a>
        </Text>
        <Divider orientation="vertical" size="small" />
        <Text size="2xsmall" color="gray">
          <a href="https://namsa.com/privacy-statement/">Privacy Policy</a>
        </Text>
      </Flex>
      <Flex ml="auto" asChild>
        <Text size="2xsmall" color="gray">
          Version{' '}
          {import.meta.env.VITE_APP_VERSION?.substring(0, 8) ?? 'v0.0.8'}
        </Text>
      </Flex>
    </Flex>
  );
};

export default Copyrights;
